import React, { FC, ReactNode } from 'react';

import { PackageStatus, PackageStatusMapped, ProjectStatus } from 'api-client';
import protection from 'assets/images/svg/protection-black.svg';
import { Image } from 'components/common/images';
import { cn } from 'utils';

import styles from './StatusBadge.module.scss';
import {
  getPackageStatusTone,
  getProjectStatusBadgeLabel,
  getProjectStatusTone,
  StatusBadgeTone,
} from './statusBadgeVariants';

type BaseProps = {
  tone?: StatusBadgeTone;
  icon?: ReactNode;
  className?: string;
  children: ReactNode;
};

export const StatusBadge: FC<BaseProps> = ({ tone = 'default', icon, className, children }) => (
  <span
    className={cn(
      styles.badge,
      tone === 'green' && styles.toneGreen,
      tone === 'default' && styles.toneDefault,
      tone === 'muted' && styles.toneMuted,
      tone === 'yellow' && styles.toneYellow,
      className
    )}
  >
    {children}
    {icon ? <span className={styles.icon}>{icon}</span> : null}
  </span>
);

type PackageStatusBadgeProps = {
  status: PackageStatus;
  className?: string;
};

export const PackageStatusBadge: FC<PackageStatusBadgeProps> = ({ status, className }) => (
  <StatusBadge tone={getPackageStatusTone(status)} className={className}>
    {PackageStatusMapped[status]}
  </StatusBadge>
);

type ProjectStatusBadgeProps = {
  status: ProjectStatus;
  className?: string;
};

export const ProjectStatusBadge: FC<ProjectStatusBadgeProps> = ({ status, className }) => (
  <StatusBadge tone={getProjectStatusTone(status)} className={className}>
    {getProjectStatusBadgeLabel(status)}
  </StatusBadge>
);

type CapitalProtectionBadgeProps = {
  className?: string;
};

export const CapitalProtectionBadge: FC<CapitalProtectionBadgeProps> = ({ className }) => (
  <StatusBadge tone="default" className={className} icon={<Image src={protection} alt="" />}>
    ЗАЩИТА КАПИТАЛА
  </StatusBadge>
);
